import React from 'react';

const INLINE_TOKEN = /(`[^`]+`|\*\*[^*]+\*\*|\*[^*]+\*|\[[^\]]+\]\((?:https?:\/\/[^)\s]+)\))/g;

function renderInline(text) {
  return text.split(INLINE_TOKEN).filter(Boolean).map((part, index) => {
    if (part.startsWith('`') && part.endsWith('`')) {
      return <code key={index} className="rounded bg-slate-100 px-1 py-0.5 text-[0.9em] dark:bg-slate-700">{part.slice(1, -1)}</code>;
    }

    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={index}>{renderInline(part.slice(2, -2))}</strong>;
    }

    if (part.startsWith('*') && part.endsWith('*')) {
      return <em key={index}>{renderInline(part.slice(1, -1))}</em>;
    }

    const linkMatch = part.match(/^\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)$/);
    if (linkMatch) {
      return (
        <a
          key={index}
          href={linkMatch[2]}
          target="_blank"
          rel="noreferrer"
          className="text-blue-600 underline decoration-blue-300 underline-offset-2 hover:text-blue-700 dark:text-blue-400"
        >
          {linkMatch[1]}
        </a>
      );
    }

    return part;
  });
}

function flushList(elements, listItems, keySeed) {
  if (listItems.length === 0) return;
  elements.push(
    <ul key={`list-${keySeed}`} className="ml-5 list-disc space-y-1">
      {listItems.map((item, index) => (
        <li key={index}>{renderInline(item)}</li>
      ))}
    </ul>
  );
  listItems.length = 0;
}

const MarkdownContent = ({ text, className = '' }) => {
  const lines = (text || '').split(/\r?\n/);
  const elements = [];
  const listItems = [];

  lines.forEach((line, index) => {
    const trimmed = line.trim();

    if (!trimmed) {
      flushList(elements, listItems, index);
      return;
    }

    const listMatch = trimmed.match(/^[-*]\s+(.+)$/);
    if (listMatch) {
      listItems.push(listMatch[1]);
      return;
    }

    flushList(elements, listItems, index);

    if (trimmed.startsWith('### ')) {
      elements.push(<h4 key={index} className="font-semibold">{renderInline(trimmed.slice(4))}</h4>);
    } else if (trimmed.startsWith('## ')) {
      elements.push(<h3 key={index} className="text-base font-semibold">{renderInline(trimmed.slice(3))}</h3>);
    } else if (trimmed.startsWith('# ')) {
      elements.push(<h2 key={index} className="text-lg font-semibold">{renderInline(trimmed.slice(2))}</h2>);
    } else {
      elements.push(<p key={index}>{renderInline(trimmed)}</p>);
    }
  });

  flushList(elements, listItems, lines.length);

  return (
    <div className={`space-y-2 break-words ${className}`}>
      {elements}
    </div>
  );
};

export default MarkdownContent;
